import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
import { AnalisarCliente } from "@/pages/MotorCredito";

function idadeFrom(dataNascimento) {
  if (!dataNascimento) return "";
  const d = new Date(dataNascimento);
  if (isNaN(d.getTime())) return "";
  return Math.floor((Date.now() - d.getTime()) / (365.25 * 24 * 3600 * 1000));
}

export default function AnaliseCreditoDialog({
  prefill,
  triggerLabel = "Análise de Crédito",
  triggerClassName = "",
  triggerVariant = "outline",
  triggerSize,
  testid = "btn-analise-credito",
}) {
  const [open, setOpen] = useState(false);
  const [bancos, setBancos] = useState([]);
  const [orgaos, setOrgaos] = useState([]);
  const [regras, setRegras] = useState([]);

  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/bancos`).then((r) => setBancos(r.data || [])).catch(() => {});
    axios.get(`${API}/lookup/instituicoes`).then((r) => setOrgaos((r.data?.instituicoes || []).map((s) => ({ id: s, nome: s })))).catch(() => {});
    axios.get(`${API}/regras-credito`).then((r) => setRegras(r.data || [])).catch(() => {});
  }, [open]);

  const pf = prefill
    ? {
        cliente: {
          vinculo: prefill.vinculo || "",
          idade: prefill.idade || idadeFrom(prefill.dataNascimento),
          orgao: prefill.orgaoNome || "",
        },
      }
    : null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant={triggerVariant} size={triggerSize} className={`gap-2 ${triggerClassName}`} data-testid={testid}>
          <ShieldCheck className="h-4 w-4" /> {triggerLabel}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-5xl max-h-[88vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-indigo-600" /> Análise de Crédito
          </DialogTitle>
        </DialogHeader>
        <AnalisarCliente bancos={bancos} orgaos={orgaos} regras={regras} prefill={pf} />
      </DialogContent>
    </Dialog>
  );
}
